// import './palette';
import { preventAppLoad } from './pre-app';

if (!preventAppLoad) {
    import('./main').then(() => {});
}
